import Cookies from "js-cookie";

const domain = import.meta.env.VITE_SESSION_DOMAIN;

const defaultConfigs = {
  domain,
  path: "/",
};

export function setValueInCookie(key: string, value: string) {
  removeValueInCookie(key);
  Cookies.set(key, value, defaultConfigs);
}

export function getValueInCookie(key: string): string {
  return Cookies.get(key);
}

export function removeValueInCookie(key: string) {
  Cookies.remove(key, defaultConfigs);
  Cookies.remove(key, {
    path: "/",
  });
  if (domain.startsWith(".")) {
    Cookies.remove(key, {
      path: "/",
      domain: domain.slice(1),
    });
  } else {
    Cookies.remove(key, {
      path: "/",
      domain: ".${domain}",
    });
  }
  if (domain.split(".").length > 2)
    Cookies.remove(key, {
      path: "/",
      domain: domain.split(".").slice(-2).join("."),
    });
}
